// import { Unzip } from "three/examples/jsm/libs/fflate.module";
import { unzip } from "three/examples/jsm/libs/fflate.module.js";

export class ZipDeCompression {

    constructor(private file: File) {}

    public async decompress(): Promise<File[]> {
        try {
            const buffer = await this.file.arrayBuffer();
            return await new Promise((resolve, reject) => {
                unzip(new Uint8Array(buffer), (err, unzipped) => {
                    if (err) {
                        reject(err);
                    }
                    const promises = Object.entries(unzipped).map(async ([filename, data]) => {
                        return new File([<any>data], filename);
                    });
                    resolve(Promise.all(promises));
                });
            });
        } catch (err) {
            return Promise.reject(new Error(`uncompress failed: ${err}`));
        }
    }
}
